import { useState } from "react";
import axios from "axios";
import './Login.scss'
import { useNavigate } from 'react-router-dom';
import MainURL from "../../MainURL";
import { useAtomValue, useSetAtom } from "jotai";
import { kaKaoLoginDataAtom, loginPathAtom, loginStateAtom, naverLoginDataAtom, userDataAtom } from "../../AtomStore";
import { mapLoginUserData, needsUserTypeSelection, USER_TYPE_ONBOARDING_PATH } from "./userTypeUtils";
import kakaologo from "../../images/login/kakao.png";
import naverlogo from "../../images/login/naver.png";
import loginBackground from "../../images/login/loginBackground.png";

export default function Login(props: any) {
  const navigate = useNavigate();
  const setIsLogin = useSetAtom(loginStateAtom);
  const setUserData = useSetAtom(userDataAtom);
  const setLoginPath = useSetAtom(loginPathAtom);
  const loginPath = useAtomValue(loginPathAtom);
  const kakaoLoginData = useAtomValue(kaKaoLoginDataAtom);
  const naverLoginData = useAtomValue(naverLoginDataAtom);

  const kakaoToken = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${kakaoLoginData.APIKEY}&redirect_uri=${kakaoLoginData.REDIRECT_URI_Auth}`;
  const naverToken = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${naverLoginData.CLIENTID}&redirect_uri=${naverLoginData.REDIRECT_URI_Auth}&state=sdfsdfsdf`;

  const [loginAccount, setLoginAccount] = useState('');
  const [loginPasswd, setLoginPasswd] = useState('');

  const handleLoginSuccess = (data: Record<string, unknown>) => {
    localStorage.setItem("refreshToken", String(data.refreshToken || ''));
    setIsLogin(true);
    setUserData(mapLoginUserData(data));

    if (needsUserTypeSelection(data)) {
      navigate(USER_TYPE_ONBOARDING_PATH, { replace: true });
      return;
    }

    window.location.replace(loginPath || '/');
  };

  const handleEmailLogin = async () => {
    await axios
      .post(`${MainURL}/login/loginemail`, {
        loginAccount,
        loginPasswd,
        userURL: 'email',
      })
      .then((res) => {
        if (res.data.isUser) {
          handleLoginSuccess(res.data);
        } else {
          if (res.data.which === 'email') {
            alert('가입되어 있지 않은 이메일 계정입니다.');
          }
          if (res.data.which === 'passwd') {
            alert('비밀번호가 정확하지 않습니다. SNS계정으로 회원가입&로그인 되어 있을수도 있습니다.');
          }
        }
      })
      .catch(() => {
        alert('다시 시도해주세요.');
      });
  };

  const handleKakaoLogin = () => {
    setLoginPath('/');
    window.location.href = kakaoToken;
  };

  const handleNaverLogin = () => {
    setLoginPath('/');
    window.location.href = naverToken;
  };

  return (
    <div className="lp">

      <main className="lp__page-wrap">
        <section className="lp__auth-grid">

          <div className="lp__auth-card">
            <div className="lp__auth-title-row">
              <div>
                <h2 className="lp__auth-title">로그인</h2>
                <p className="lp__auth-subtitle">
                  사역자모아 계정으로 로그인하고 청빙, 수련회, 예배사역 정보를 편리하게 이용해보세요.
                </p>
              </div>
              <span className="lp__auth-link" onClick={() => navigate(USER_TYPE_ONBOARDING_PATH, { state: { signupFlow: true } })}>
                처음이신가요?
              </span>
            </div>

            <div className="lp__social-row">
              <div className="lp__social-box lp__social-box--kakao" onClick={handleKakaoLogin}>
                <div className="lp__social-icon lp__social-icon--kakao">
                  <img src={kakaologo} alt="카카오" />
                </div>
                <strong>카카오</strong>
                <span>간편 시작</span>
              </div>
              <div className="lp__social-box lp__social-box--naver" onClick={handleNaverLogin}>
                <div className="lp__social-icon lp__social-icon--naver">
                  <img src={naverlogo} alt="네이버" />
                </div>
                <strong>네이버</strong>
                <span>빠른 연동</span>
              </div>
            </div>

            <div className="lp__divider">또는 이메일로 로그인</div>

            <form
              className="lp__form-grid"
              onSubmit={(e) => {
                e.preventDefault();
                setLoginPath('/');
                handleEmailLogin();
              }}
            >
              <label className="lp__field">
                <span className="lp__field-label">이메일</span>
                <input
                  className="lp__input"
                  type="email"
                  placeholder="example@church.or.kr"
                  value={loginAccount}
                  onChange={(e) => setLoginAccount(e.target.value)}
                />
              </label>

              <label className="lp__field">
                <span className="lp__field-label">
                  비밀번호
                  <small>8자 이상 권장</small>
                </span>
                <input
                  className="lp__input"
                  type="password"
                  placeholder="비밀번호를 입력하세요"
                  value={loginPasswd}
                  onChange={(e) => setLoginPasswd(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && loginAccount && loginPasswd) {
                      setLoginPath('/');
                      handleEmailLogin();
                    }
                  }}
                />
              </label>

              <div className="lp__caption-row">
                {/* <label><input type="checkbox" defaultChecked /> 로그인 상태 유지</label> */}
                <span className="lp__auth-link">비밀번호 찾기</span>
              </div>

              <div className="lp__form-actions">
                <button
                  className="lp__btn lp__btn--primary lp__btn--full"
                  type="submit"
                  disabled={!loginAccount || !loginPasswd}
                >
                  이메일로 로그인
                </button>
              </div>
            </form>

            <div className="lp__mini-section">
              <article className="lp__mini-card">
                <span className="lp__rank-chip lp__rank-chip--blue">추천 서비스</span>
                <strong>최신 청빙공고</strong>
                <p>지역, 사역형태, 사례비 조건을 기준으로 빠르게 비교하세요.</p>
              </article>
              <article className="lp__mini-card">
                <span className="lp__rank-chip lp__rank-chip--green">인기 카테고리</span>
                <strong>예배사역 자료</strong>
                <p>콘텐츠와 예배 운영 정보까지 한 흐름으로 이어서 확인할 수 있습니다.</p>
              </article>
            </div>
          </div>

          <div className="lp__hero-panel">
            <div className="lp__hero-badge">사역의 연결을 더 빠르고 선명하게</div>
            <h1 className="lp__hero-title">
              교회와 사역자를 잇는<br />
              가장 <span className="lp__accent">효율적인 시작점</span>
            </h1>
            <p className="lp__hero-desc">
              사역자모아는 교회 구인구직, 수련회 장소, 예배사역 정보를 하나의 흐름으로 연결해
              바쁜 목회자와 전도사가 더 빠르게 필요한 정보를 찾을 수 있도록 돕습니다.
            </p>

            <div className="lp__info-cards">
              <article className="lp__info-card">
                <span className="lp__tag lp__tag--new">NEW</span>
                <h3>구인구직</h3>
                <p>최신 청빙 공고를 빠르게 확인하고, 사역 환경에 맞는 포지션을 찾으세요.</p>
              </article>
              <article className="lp__info-card">
                <span className="lp__tag lp__tag--best">BEST</span>
                <h3>수련회 장소</h3>
                <p>지역·규모별 수련회 장소를 한눈에 비교하며 준비 시간을 줄일 수 있습니다.</p>
              </article>
            </div>

            <img src={loginBackground} alt="" className="lp__hero-img" aria-hidden="true" />
          </div>

        </section>
      </main>

    </div>
  );
}
